module.exports = __webpack_public_path__ + "static/media/practical.35c19d18.svg";